import React, { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultState = {
  userLoggedInText: 'Go to the dashboard',
  learnMoreText: 'Learn more',
  tagCategories: {
    academy: 'Academy',
    blog: 'Blog',
    community: 'Community',
    event: 'Event',
    guide: 'Guide',
    'help-center': 'Help center',
    news: 'News',
    template: 'Template',
    'use-case': 'Use case',
    'whats-new': "What's new"
  }
};
var TextTokensContext = /*#__PURE__*/createContext(defaultState);
export var TextTokensProvider = function TextTokensProvider(_ref) {
  var children = _ref.children,
      initialState = _ref.initialState;
  return /*#__PURE__*/_jsx(TextTokensContext.Provider, {
    value: initialState,
    children: children
  });
};
export var useTextTokens = function useTextTokens() {
  return useContext(TextTokensContext);
};